import {
  Document,
  Page,
  StyleSheet,
  Text,
  View,
  Font,
  Image,
} from "@react-pdf/renderer";
import React, { useCallback, useEffect, useState } from "react";

import ThSarabun from "../../fonts/THSarabunNew.ttf";
import ThSarabunBold from "../../fonts/THSarabunNew-Bold.ttf";
import ThSarabunItalic from "../../fonts/THSarabunNew-Italic.ttf";
import ThSarabunBoldItalic from "../../fonts/THSarabunNew-BoldItalic.ttf";
import { ConvertDateFromSQL } from "../../core/ThaiDate";
import { DOCU_MARGIN } from "../../core/Helper";

// import axios from "axios";
// import ImageLogo from "../../images/logo_branch_1.png";

export default function DocumentBuilder(props) {
  const { data, setLoading, userDetail } = props;

  let tmp = new Date().toLocaleDateString("en-EN");
  Font.register({ family: "ThSarabun", src: ThSarabun });
  Font.register({ family: "ThSarabunBold", src: ThSarabunBold });
  Font.register({ family: "ThSarabunItalic", src: ThSarabunItalic });
  Font.register({ family: "ThSarabunBoldItalic", src: ThSarabunBoldItalic });

  // process.env.REACT_APP_PHOTO + "/branch_logos/logo_branch_" +  data?.studyInfo.brchid + ".png";

  useEffect(() => {
    console.log("DocumentBuilder said:");
    console.log(data);
    console.log("./logos/logo_branch_" + data?.studyInfo.brchid + ".png");
    //console.log(userDetail);
  }, [data]);

  return (
    <Document
      keywords={tmp}
      title="Radiologist Result Preview"
      style={{ fontFamily: fontName }}
      onRender={(a) => {
        if (a.url != null) {
          setLoading(false);
        }
      }}
    >
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          {/*  */}
          {/* LOGO */}
          <View style={styles.headerLogo}>
            <Image
              src={"/logos/logo_branch_" + data?.studyInfo.brchid + ".png"}
            />
          </View>

          {/* Name */}

          <View style={styles.headerBranch}>
            <Text style={styles.headerBranchName}>
              {data &&
                data?.studyInfo?.cust_prefix + data?.studyInfo?.cust_name}
            </Text>
            <Text style={styles.headerBranchAddr}>
              {" "}
              {data && data?.studyInfo?.cust_addr1}
            </Text>
            <Text style={styles.headerBranchAddr}>
              {data && data?.studyInfo?.cust_addr2}
            </Text>
            <Text style={styles.headerBranchAddr}>
              {"โทรศัพท์ "}
              {data && data?.studyInfo?.cust_phone}
            </Text>
          </View>
        </View>

        {/* PAGE HEADER */}

        <View style={styles.pageHeader} fixed>
          <View style={styles.footerDetail}>
            <Text
              render={({ pageNumber }) =>
                pageNumber > 1 ? "Radiologist Diagnostic Result" : ""
              }
            />
            <Text
              render={({ pageNumber, totalPages }) =>
                pageNumber > 1 ? `Page : ${pageNumber} / ${totalPages}` : ""
              }
            />
          </View>
          <View style={{ borderWidth: 0.5, borderColor: "gray" }} />
        </View>

        {/* Patient Infomation */}
        <View style={styles.patientInfo}>
          {/* Line 1 */}
          <View style={styles.linePatInfo}>
            <View style={styles.infoBox}>
              <Text style={styles.infoBoxLabel}>Patient Name: </Text>
              <Text>{data?.studyInfo?.patients_name}</Text>
            </View>
          </View>
          {/* Line 2 */}
          <View style={styles.linePatInfo}>
            <View style={styles.infoBox}>
              <Text style={styles.infoBoxLabel}>HN: </Text>
              <Text>{data?.studyInfo?.patientid}</Text>
            </View>
            <View style={styles.infoBox}>
              <Text style={styles.infoBoxLabel}>Age: </Text>
              <Text>
                {/* {data?.studyInfo?.patients_age} */}
                {data?.studyInfo?.patients_age
                  ?.replace(/^0+/g, "")
                  ?.replace(/[y,Y]/g, " ปี")
                  ?.replace(/[m,M]/, " เดือน")}
              </Text>
            </View>
            <View style={styles.infoBox}>
              <Text style={styles.infoBoxLabel}>Sex: </Text>
              <Text>
                {/* {data?.studyInfo?.patients_sex} */}

                {data?.studyInfo?.patients_sex
                  ?.replace(/[Mm]/g, "ชาย")
                  .replace(/[Ff]/g, "หญิง") ?? "ไม่ทราบเพศ"}
              </Text>
            </View>
          </View>
          {/* Line 3 */}
          <View style={styles.linePatInfo}>
            <View style={styles.infoBox}>
              <Text style={styles.infoBoxLabel}>Part Examine: </Text>
              <Text>
                {/* {data?.priceItems[0].goodname} */}

                {data?.priceItems?.map((item, index) => {
                  return index > 0
                    ? ", " + item?.goodname ?? ""
                    : item?.goodname ?? "";
                })}
              </Text>
            </View>
          </View>
          {/* Line 4 */}
          <View style={styles.linePatInfo}>
            <View style={styles.infoBox}>
              <Text style={styles.infoBoxLabel}>รังสีแพทย์: </Text>
              <Text>{data?.studyInfo?.radi_staff_name}</Text>
            </View>

            <View style={styles.infoBox}>
              <Text style={styles.infoBoxLabel}>วัน-เวลา อ่านผล: </Text>
              <Text>
                {ConvertDateFromSQL(data?.studyResult[0]?.result_date)}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ borderWidth: 0.5, borderColor: "gray" }} />
        {/* End Patient information */}

        {/* BODY */}
        <View style={styles.body}>
          <Text>
            {data &&
              data?.studyResult[0]?.result_text &&
              data?.studyResult[0]?.result_text}
          </Text>
        </View>
        {/* End page body */}
        {/* Footer  */}
        <View style={styles.footer} fixed>
          <View style={{ borderWidth: 0.5, borderColor: "gray" }} />
          <View style={styles.footerDetail}>
            <Text>Radiologist Diagnostic Result</Text>
            <Text
              render={({ pageNumber, totalPages }) =>
                `Page : ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
      </Page>
    </Document>
  );
}

const fontNameTh = "ThSarabun";
const fontBoldTh = "ThSarabunBold";
const fontName = "Courier";
const fontBold = "Courier";

const styles = StyleSheet.create({
  //** Document and Page */
  document: { flex: 1 },
  page: {
    fontFamily: fontName,
    flexDirection: "column",
    borderWidth: 1,
    paddingTop: DOCU_MARGIN.top,
    paddingLeft: DOCU_MARGIN.left,
    paddingRight: DOCU_MARGIN.right,
    paddingBottom: DOCU_MARGIN.bottom,
    fontSize: 14,
  },

  //** Header */
  header: {
    display: "flex",
    flexDirection: "row",
    // marginHorizontal: 10,
    alignItems: "center",
    paddingVertical: 10,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: "grey",
  },
  headerLogo: {
    flex: 0.2,
    border: 1,
    borderColor: "#a1eeb8",
    padding: 5,
    margin: 10,
    textAlign: "center",
    borderRadius: 10,
  },

  //** Branch */
  headerBranch: {
    flex: 1,
    fontSize: 10,
    paddingHorizontal: 10,
    // paddingVertical: 5,
    justifyContent: "center",
    fontFamily: fontNameTh,
  },

  headerBranchName: {
    fontFamily: fontBoldTh,
    lineHeight: 1,
    fontSize: 20,
    textAlign: "center",
  },

  headerBranchAddr: {
    fontFamily: fontNameTh,
    lineHeight: 0.9,
    fontSize: 14,
    textAlign: "center",
  },

  pageHeader: {
    marginTop: 5,
  },

  patientInfo: {
    fontFamily: fontNameTh,
    lineHeight: 1,
    paddingVertical: 10,
    marginVertical: 5,
  },

  infoBox: {
    fontFamily: fontNameTh,
    flexDirection: "row",
    justifyContent: "center",
  },

  infoBoxLabel: {
    fontWeight: "bold",
    fontFamily: fontBoldTh,
  },

  linePatInfo: {
    flexDirection: "row",
    justifyContent: "space-between",
    fontFamily: fontNameTh,
    paddingTop: "3px",
  },
  //** Body */
  body: {
    // flex: 1,
    marginBottom: 30,
    fontSize: 10,
    lineHeight: 1.5,
  },

  footer: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    marginLeft: DOCU_MARGIN.left,
    marginRight: DOCU_MARGIN.right,
    flexDirection: "column",
  },

  footerDetail: {
    fontSize: 12,
    textAlign: "center",
    color: "grey",
    justifyContent: "space-between",
    flexDirection: "row",
    fontFamily: fontNameTh,
  },
});
